
import { mapState } from 'vuex'

export default {
  middleware({ route, redirect }) {
    if (route.path === '/purchase' || route.path === '/purchase/') {
      return redirect('/purchase/licenses')
    }
  },
  props: {
    bannersData: {
      type: Object,
      default: () => ({
        topBannerTextCurrency: '$',
        topBannerTextAmount: 30,
        payLaterBoldedText: 'TOP_LINE_PAY_LATER',
        payLaterFreePaymentsHeader: 'TOP_LINE_PAY_LATER_BAR',
        payLaterFreePaymentsContent: 'TOP_LINE_PAY_LATER_FREE_PAYMENTS_CONTENT',
        payLaterBlueText: 'TOP_LINE_PAY_LATER_BLUE_TEXT',
        payLaterIconName: 'pay-later',
        // interestPaymentCount: 3,
        //  currency: '$',
        //   amount: 10.32,
        weeksCount: 2,
        licenseLink: { name: 'STEP_BAR_EULA', link: 'URL_LICENSING', title: 'STEP_BAR_EULA_TITLE' },
      }),
    },
    stepperData: {
      type: Object,
      default: () => ({
        btn_back: 'STEPS_BAR_BTN_BACK',
        btn_skip: 'SKIP_BNT',
        btn_next: 'STEPS_BAR_BTN_NEXT',
      }),
    },
  },
  data() {
    const SD_Organization = {
      '@context': 'http://schema.org',
      '@type': 'Organization',

      name: this.$i18n.t('SD_ORGANIZATION_NAME'),
      url: this.$i18n.t('SD_ORGANIZATION_URL'),
      image: this.$i18n.t('SD_ORGANIZATION_IMAGE'),
      telephone: [
        this.$i18n.t('SD_ORGANIZATION_PHONE_USA'),
        this.$i18n.t('SD_ORGANIZATION_PHONE_UK'),
        this.$i18n.t('SD_ORGANIZATION_PHONE_CANADA'),
        this.$i18n.t('SD_ORGANIZATION_PHONE_FRANCE'),
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: this.$i18n.t('SD_ORGANIZATION_ADDRESS'),
        addressLocality: this.$i18n.t('SD_ORGANIZATION_CITY'),
        postalCode: this.$i18n.t('SD_ORGANIZATION_ZIP'),
        addressRegion: this.$i18n.t('SD_ORGANIZATION_REGION'),
        addressCountry: this.$i18n.t('SD_ORGANIZATION_COUNTRY'),
      },
    }
    const SD_SoftwareApp = {
      '@context': 'http://schema.org',
      '@type': 'SoftwareApplication',
      image: this.$i18n.t('SD_PR_IMAGE'),
      name: this.$i18n.t('SD_PR_NAME'),
      description: this.$i18n
        .t('SD_PR_DESCRIPTION')
        .toString()
        .replace(/#PR_NAME#/g, this.$config.CustomProductData.currentPrName),
      operatingSystem: this.$i18n.t('SD_PR_OPERATING_SYSTEM'),
      url: this.$i18n.t('SD_PR_URL'),
      downloadURL: this.$i18n.t('SD_PR_DOWNLOAD_URL'),
      applicationCategory: this.$i18n.t('SD_PR_CATEGORY'),
      softwareVersion: this.$i18n.t('SD_PR_VERSION'),
      releaseNotes: this.$i18n.t('SD_PR_RELEASE_NOTES'),
      author: {
        '@type': 'Organization',
        name: this.$i18n.t('SD_PR_AUTHOR_NAME'),
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        worstRating: this.$i18n.t('SD_RATING_WORST'),
        bestRating: this.$i18n.t('SD_RATING_BEST'),
        ratingValue: this.$i18n.t('SD_RATING_VALUE'),
        reviewCount: this.$i18n.t('SD_RATING_COUNT'),
      },
      offers: [
        {
          '@type': 'Offer',
          priceCurrency: this.$i18n.t('SD_OFFERS_PRICE_CURRENCY_USD'),
          price: this.$i18n.t('SD_OFFERS_PRICE_USD'),
          url: this.$i18n.t('SD_OFFERS_URL_USD'),
        },
        {
          '@type': 'Offer',
          priceCurrency: this.$i18n.t('SD_OFFERS_PRICE_CURRENCY_EUR'),
          price: this.$i18n.t('SD_OFFERS_PRICE_EUR'),
          url: this.$i18n.t('SD_OFFERS_URL_EUR'),
        },
        {
          '@type': 'Offer',
          priceCurrency: this.$i18n.t('SD_OFFERS_PRICE_CURRENCY_GBP'),
          price: this.$i18n.t('SD_OFFERS_PRICE_GBP'),
          url: this.$i18n.t('SD_OFFERS_URL_GBP'),
        },
      ],
    }
    return {
      isLoaded: false,
      scrollY: null,
      headerBottom: 0,
      isStepperSticky: true,
      expandTopBanner: false,
      expand: false,
      show: true,
      srcImg: '',
      currentRoute: '',
      SD_SoftwareApp,
      SD_Organization,
      internalCreationId: Math.random(),
      internalName: 'default.vue',
    }
  },
  head() {
    let step = this.steps.find((el) => el.Link === this.$route.params.id)

    if (!step) {
      const curUrl = this.$route.path.split('/').reverse()[0]
      step = this.steps.find((el) => el.Link === curUrl)
    }

    if (!step) {
      return {
        title: this.$config.CustomProductData.currentPrName,
        meta: [
          {
            name: 'description',
            hid: 'description',
            content: this.$config.CustomProductData.currentPrName,
          },
          { name: 'keywords', content: this.$config.CustomProductData.currentPrName },
        ],
      }
    }

    const metaInfo = {
      title: this.$t(step.MetaTitle).replace(/#PR_NAME#/g, this.$config.CustomProductData.currentPrName),
      meta: [
        {
          name: 'description',
          hid: 'description',
          content: this.$t(step.MetaDescription).replace(/#PR_NAME#/g, this.$config.CustomProductData.currentPrName),
        },
        { name: 'keywords', content: this.$t(step.MetaKeywords).replace(/#PR_NAME#/g, this.$config.CustomProductData.currentPrName) },
      ],
      script: step.Scripts?.map((x) => {
        return {
          src: x,
        }
      }),
    }

    if (step.Scripts && step.Scripts.length > 0) {
      for (let i = 0; i < step.Scripts; i++) {
        metaInfo.script.push({ src: step.Scripts[i] })
      }
    }

    return metaInfo
  },
  computed: mapState({
    cards: (state) => state.cards.cards,
    currentStepSelectedCards: (state) => state.cards.currentStepSelectedCards,
    nextStepLink: (state) => state.steps.nextStepLink,
    previousStepLink: (state) => state.steps.previousStepLink,
    currentSteps: (state) => state.steps.currentSteps,
    currentStep: (state) => state.steps.currentStep,
    currentStepNumber: (state) => state.steps.currentStepNumber,
    currentStepMinCards: (state) => state.steps.currentStepMinCards,
    currentStepMaxCards: (state) => state.steps.currentStepMaxCards,
    currentStepIsValid: (state) => state.steps.currentStepIsValid,
    selectedLocale: (state) => state.locales.selectedLocale,
    currencies: (state) => state.currencies,
    locales: (state) => state.locales.locales,
    selectedCurrency: (state) => state.currencies.selectedCurrency,
    steps: (state) => state.steps.steps,
    isFinalStep: (state) => state.steps.isFinalStep,
    isNextActionCustom: (state) => state.steps.isNextActionCustom,
  }),
  watch: {
    group() {
      this.drawer = false
    },
    selectedCurrency() {
      if (this.isLoaded) {
        this.whichBanner()
        this.DiscountBannerURL()
      }
    },
    selectedLocale() {
      if (this.isLoaded) {
        this.whichBanner()
        this.DiscountBannerURL()
      }
    },
  },
  async beforeMount() {
    const languages = ['en', 'de', 'fr', 'es', 'it']

    if (!this.$services.culture.isSet()) {
      await this.cultureDefault()
    }

    let currency = this.$services.culture.getCurrency()
    let lang = this.$services.culture.getLanguage()

    if (!Array.from(this.currencies.currencies).some((x) => x.currency === currency)) {
      currency = 'USD'
    }

    if (this.$route.fullPath.split('/').length > 3 && languages.findIndex((x) => this.$route.fullPath.split('/')[1].includes(x)) !== -1) {
      const urlLanguage = languages.find((x) => this.$route.fullPath.split('/')[1].includes(x))
      this.$services.culture.setLanguage(urlLanguage)
    } else if (languages.findIndex((x) => x === lang) === -1) {
      lang = 'en'
      this.$services.culture.setLanguage(lang)
    } else if (lang !== 'en') {
      window.location.href = '/' + lang + this.$route.fullPath
    }
    const selectedCurrency = this.currencies.currencies.find((x) => x.currency === currency)
    const selectedLocale = this.locales.find((x) => x.code === lang)

    await this.setSelectedCurrency(selectedCurrency)
    await this.setSelectedLocale(selectedLocale)
    this.currentRoute = this.$route.fullPath.includes('licenses')

    let bannerShownAt = new Date()
    bannerShownAt.setHours(0, 0, 0, 0)

    if (this.$services.cookies.get('bannerShown') === null) {
      await this.$services.cookies.set('bannerShown', bannerShownAt.getTime(), 'never')
    } else {
      let valFromCookie = this.$services.cookies.get('bannerShown')

      if (valFromCookie.includes('"')) valFromCookie = valFromCookie.replaceAll('"', '')
      if (valFromCookie.includes("'")) valFromCookie = valFromCookie.replaceAll("'", '')

      bannerShownAt = Date.parse(valFromCookie)
      if (isNaN(bannerShownAt)) {
        const parsedInt = parseInt(valFromCookie)
        if (!isNaN(parsedInt)) {
          bannerShownAt = new Date(parsedInt)
        } else {
          bannerShownAt = new Date()
          bannerShownAt.setHours(0, 0, 0, 0)
          await this.$services.cookies.set('bannerShown', bannerShownAt.getTime(), 'never')
        }
      }
    }

    const bannerExpires = new Date(bannerShownAt)
    bannerExpires.setDate(bannerExpires.getDate() + 1)
    bannerExpires.setHours(0, 0, 0, 0)

    const now = new Date()

    if (bannerExpires <= now || this.$route.name.includes('licenses')) {
      this.show = false
    }
    setTimeout(async () => {
      await this.sendPcode(this.$route.query.pcode)
    }, 100)
  },
  mounted() {
    if (process.browser) {
      this.$nextTick(() => {
        this.$nuxt.$loading.start(this.internalCreationId, this.internalName)
        setTimeout(() => this.$nuxt.$loading.finish(this.internalCreationId, this.internalName), 500)
      })
      this.whichBanner()
      this.DiscountBannerURL()
      this.isLoaded = true
    }
  },
  methods: {
    setSelectedCurrency(val) {
      this.$store.commit('currencies/setSelectedCurrency', val)
    },
    setSelectedLocale(val) {
      this.$store.commit('locales/setSelectedLocale', val)
    },
    async sendPcode(pcode) {
      await this.$services.tracking.track(pcode)
    },
    async cultureDefault() {
      let prevCurrency = ''
      if (localStorage.getItem('currency_name')) {
        prevCurrency = localStorage.getItem('currency_name').split(' ')[0]
      }

      await this.$services.culture.cultureDefault(prevCurrency)
    },
    MobileDevice() {
      let MobileVar = false
      /* start show different banner for mobile devices */
      const ua = navigator.userAgent.toLowerCase()
      const platform = navigator?.platform.toLowerCase() || 'unknown'
      const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
      MobileVar = /ios|android|webos/.test(platformName)
      return MobileVar
      /* end show different banner for mobile devices */
    },
    whichBanner() {
      /* start show different banner for mobile devices */
      const ua = navigator.userAgent.toLowerCase()
      let bannerMobile = ''
      const platform = navigator?.platform.toLowerCase() || 'unknown'
      const platformName = ua.match(/ip(?:ad|od|hone)/) ? 'ios' : (ua.match(/(?:webos|android)/) || platform.match(/mac|win|linux/) || ['other'])[0]
      const isMobile = /ios|android|webos/.test(platformName)
      if (isMobile) {
        bannerMobile = '_m'
      }
      /* end show different banner for mobile devices */
      let lang = 'en'
      let currency = 'USD'
      if (this.$services.culture.isSet()) {
        lang = this.$services.culture.getLanguage()
        const currencyTest = this.$services.culture.getCurrency()
        const currenciesArray = this.currencies.currencies
        currency = currenciesArray.find((x) => x.currency === currencyTest)?.currency
        if (currency === undefined) currency = 'USD'
      }

      if (lang === 'de' || lang === 'es' || lang === 'fr' || lang === 'it')
        this.srcImg =
          'https://www.4team.biz/i/banners/' + this.$config.CustomProductData.GleamBannerFolder + '/gleam_banner_' + lang + '_EUR' + bannerMobile + '.png'
      else if (currency === 'HKD' || currency === 'JPY')
        this.srcImg = 'https://www.4team.biz/i/banners/' + this.$config.CustomProductData.GleamBannerFolder + '/gleam_banner_USD' + bannerMobile + '.png'
      else
        this.srcImg =
          'https://www.4team.biz/i/banners/' + this.$config.CustomProductData.GleamBannerFolder + '/gleam_banner_' + currency + bannerMobile + '.png'

      return this.srcImg
    },
    showPayLaterMessage() {
      const curCard = this.cards.find((el) => el.StepLink === this.currentStep)
      return this.isLoaded && !this.MobileDevice() && curCard && curCard.IsSplitPaymentForbidden !== true
    },
    /* Start Show Additional text with discount */
    CheckQueryParameters() {
      const promoDicount = this.$route.query.d
      const promoCode = this.$route.query.p
      const promoCurrency = this.$route.query.c

      return !!promoDicount && !!promoCode && !!promoCurrency
    },
    ShowAdditionalDiscountText(param) {
      if (param === 'getCurrency') {
        return this.$route.query.c
      } else if (param === 'getPromoCode') {
        return this.$route.query.p
      } else if (param === 'getPercents') {
        return this.$route.query.d
      } else {
        return false
      }
    },
    /* End show additional text with applied discount */
    /* Pass correct url for DiscountBanner */
    DiscountBannerURL() {
      let lang = ''
      let currency = 'USD'
      let urlBannerLanguage = ''
      if (this.$services.culture.isSet()) {
        lang = this.$services.culture.getLanguage()
        const currencyTest = this.$services.culture.getCurrency()
        const currenciesArray = this.currencies.currencies
        currency = currenciesArray.find((x) => x.currency === currencyTest)?.currency
        if (currency === undefined) currency = 'USD'
      }
      var customLocalesArray = this.$config.CustomProductData.supportedLanguages.split(',')
      if (customLocalesArray.indexOf(lang) < 0) {
        lang = 'en'
      }
      if (lang === '/de' || lang === '/es' || lang === '/fr' || lang === '/it' || lang === 'de' || lang === 'es' || lang === 'fr' || lang === 'it') {
        currency = 'EUR'
        lang = lang + '/'
      }
      if (currency === 'HKD' || currency === 'JPY') currency = 'USD'
      if (lang === 'en' || lang === '/en') {
        lang = ''
      }
      urlBannerLanguage = lang
      return this.$config.CustomProductData.ProductWebUrl + urlBannerLanguage + this.$config.CustomProductData.GleamBannerPage + '?splurgy_curr=' + currency
    },
    /* Pass correct url for DiscountBanner */
    isLicensesPage() {
      return this.$route.path.includes('licenses')
    },

    isPricingPage() {
      return this.$route.path.includes('/purchase/')
    },
    isLastStep() {
      const currentStepsLastLink = this.currentSteps[this.currentSteps.length - 1]?.Link
      return this.currentStep === currentStepsLastLink
    },
    isRequiredStep() {
      const currentStepsIsRequired = this.cards.find((el) => el.StepLink === this.currentStep)?.IsRequiredStep
      const currentStepsIsRequired2 = this.steps.find((el) => el.Link === this.currentStep)?.IsRequiredStep
      return currentStepsIsRequired === true || currentStepsIsRequired2 === true
    },
    isStepperNextButtonEnabled() {

      return this.currentStepSelectedCards.length >= this.currentStepMinCards && (!this.isRequiredStep() || this.currentStepIsValid)
    },
    openLikePage() {
      const url =
        'https://www.facebook.com/plugins/error/confirm/like?iframe_referer=https%3A%2F%2Fwww.sync2.com%2F&kid_directed_site=false&secure=true&plugin=like&return_params=%7B%22href%22%3A%22https%3A%2F%2Fwww.facebook.com%2F4TeamCorporation%2F%22%2C%22width%22%3A%22120px%22%2C%22layout%22%3A%22button_count%22%2C%22action%22%3A%22recommend%22%2C%22size%22%3A%22small%22%2C%22share%22%3A%22false%22%2C%22height%22%3A%2221%22%2C%22appId%22%3Anull%2C%22ret%22%3A%22sentry%22%2C%22act%22%3A%22recommend%22%7D'
      const title = 'name'
      const w = 600
      const h = 400
      const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX
      const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY

      const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width
      const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height

      const systemZoom = width / window.screen.availWidth
      const left = (width - w) / 2 / systemZoom + dualScreenLeft
      const top = (height - h) / 2 / systemZoom + dualScreenTop
      window.open(
        url,
        title,
        `
      scrollbars=yes,
      width=${w / systemZoom},
      height=${h / systemZoom},
      top=${top},
      left=${left}
      `
      )
    },
  },
}
